import {
  filterPatientsNotAttendedInPeriod,
  filterPatientsWithAppointmentInPeriod,
} from "../aggregations";
import type { CrmPatientSummary } from "../types";
import type { PatientFinderAppointmentMode } from "./patientFinderAppointmentMode";

/**
 * Aplica inclusão ou exclusão conforme o modo escolhido na UI.
 */
export function applyPatientFinderAppointmentMode(
  allPatients: CrmPatientSummary[],
  matchingPatientIds: Set<string>,
  mode: PatientFinderAppointmentMode,
): CrmPatientSummary[] {
  if (mode === "not_attended") {
    return filterPatientsNotAttendedInPeriod(allPatients, matchingPatientIds);
  }
  return filterPatientsWithAppointmentInPeriod(allPatients, matchingPatientIds);
}
